<template>
  <div>
    <food-diary v-if="showPrivacyFood && profile.information && profile.information.basic" :userId="profile.information.basic.user_id"></food-diary>
    <p v-if="!showPrivacyProgress">User has chosen to keep their food diary private</p>
  </div>
</template>
<script>
  import ProfileMixin from "../../mixins/ProfileMixin";
  import FoodDiary from "../../components/Profile/FoodDiary/FoodDiary";

  export default {
    components: {FoodDiary},
    watch: {
      "$route": function() {
        self.profile = self.getProfile();
      }
    },
    mixins: [
      ProfileMixin
    ],
    data() {
      return {
        profile: {}
      }
    },
    mounted() {
      let self = this;
      self.profile = self.getProfile();
    }
  }

</script>



// WEBPACK FOOTER //
// ProfileFood.vue?1db0d192